import { useEffect, useState } from "react";
import { adminService } from "../../../../services/admin-service";
import { AdminPageHeader, AdminPanel, EmptyState, StatusBadge, formatDate } from "./admin-ui";
import ApplicantDataTable from "../../../common/applicant-data-table";

function AdminApplicationsPage({ type }) {
    const isResume = type === "resumes";
    const [rows, setRows] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const request = isResume ? adminService.resumes() : adminService.applications();
        request.then((data) => setRows(isResume ? data.resumes || [] : data.applications || []))
            .catch((error) => setMessage(error.message));
    }, [isResume]);

    return (
        <>
            <AdminPageHeader title={isResume ? "Resumes" : "Applications"} subtitle={isResume ? "Private file metadata" : "Candidate application monitoring"} />
            {message && <div className="alert alert-info">{message}</div>}
            <AdminPanel title={isResume ? "Resume Metadata" : "Application List"} icon={isResume ? "fa fa-id-card" : "fa fa-file-alt"}>
                {isResume ? <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr><th>File</th><th>Candidate</th><th>Type</th><th>Size</th><th>Uploaded</th></tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 ? (
                                <tr><td colSpan={5}><EmptyState text="No resume uploads found." /></td></tr>
                            ) : rows.map((resume) => (
                                <tr key={resume.id}>
                                    <td>{resume.file_name}<div className="text-muted">{resume.object_key}</div></td>
                                    <td>{resume.candidate_name}<div className="text-muted">{resume.candidate_email}</div></td>
                                    <td>{resume.content_type}</td>
                                    <td>{formatBytes(resume.size || resume.size_bytes)}</td>
                                    <td>{formatDate(resume.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div> : (
                    <ApplicantDataTable
                        applications={rows}
                        title="Admin Applications"
                        emptyText="No candidate applications found."
                        renderActions={(application) => <StatusBadge status={application.status || "submitted"} />}
                    />
                )}
            </AdminPanel>
        </>
    );
}

function formatBytes(value) {
    const bytes = Number(value || 0);
    if (!bytes) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export default AdminApplicationsPage;
